export enum LoadingPosition {
    LEFT = 'left',
    RIGHT = 'right'
}
